



















































































import { Component, Vue } from 'vue-property-decorator';
import '@/assets/scss/pages/page-auth.scss';
import { XIcon, UploadIcon } from 'vue-feather-icons';
import FileInboxOverview from './FileInboxOverview.vue';
import { IFile } from 'admiral-core';
import { FileApi } from '@/services/FileApi';
import UploadFiles from '@/components/common/UploadFiles.vue';

@Component({
  name: 'file-inbox',
  components: { XIcon, FileInboxOverview, UploadIcon, UploadFiles },
})
class FileInbox extends Vue {
  search = true;
  searchQuery = '';
  isContentHovered = false;
  isLoading = false;
  newUploadedFiles: any[] = [];

  files: IFile[] = [];

  async mounted() {
    await this.reload();
  }

  async loadFiles() {
    try {
      this.isLoading = true;
      this.$Progress.start();

      const files = await FileApi.getFiles();

      this.files = files.data as IFile[];
    } catch (e) {
      this.$toastr.e(
        'Beim Abrufen der Dateien ist etwas schiefgegangen. Wir haben den Fehler erfasst und kümmern uns schnellstmöglich.',
      );
      this.isLoading = false;
      this.$Progress.finish();
      throw e;
    }
    this.isLoading = false;
    this.$Progress.finish();
  }

  async reload() {
    await this.loadFiles();
  }

  async cancelUpload() {
    (this.$refs['modal-upload-files'] as any).hide();
  }

  async uploadFiles() {
    const response = await FileApi.uploadFiles(this.newUploadedFiles);
    await this.reload();
    this.newUploadedFiles = [];
    (this.$refs['modal-upload-files'] as any).hide();
  }
}

export default FileInbox;
